export enum Role {
    ADM = 'SEVI_ADM[*]',
    SIND = 'SEVI_SIND[*]',
    ELEITOR = 'SEVI_ELEITOR[*]',
}
